import MarketStateExportFilter from '@app/model/market_state/_export/MarketStateExportFilter';

export enum ReportType {
	REVIEWS_INSIGHTS = 'REVIEWS_INSIGHTS',
	MARKET_STATE_EXPORT = 'MARKET_STATE_EXPORT',
	PARITY_EXPORT = 'PARITY_EXPORT',
}

export enum ReportScope {
	SAVED = 'SAVED',
	ON_DEMAND = 'ON_DEMAND',
}

export enum MarketStateExportReportPeriod {
	CURRENT_MONTH = 'CURRENT_MONTH',
	MONTHS_3 = 'MONTHS_3',
	MONTHS_6 = 'MONTHS_6',
	MONTHS_12 = 'MONTHS_12',
	CUSTOM_DATES = 'CUSTOM_DATES',
}

type MarketStateExportReport = {
	id: number
	companyHotelId: number
	name: string
	creationDate: string
	reportType: ReportType
	scope: ReportScope
	period: MarketStateExportReportPeriod
	fromDate: string | null
	toDate: string | null
	filter: MarketStateExportFilter
}

export default MarketStateExportReport;
